/* eslint-disable camelcase */
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getEnv } from '@config';
import { moneyFormat } from '@helpers';
import { formatDate } from '@helpers/date'; 
import Divider from '../../Divider';
import { TitleAndText } from './TitleAndText';

const Title = styled.div`
  color: #505050;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  width: 100%;
  max-width: 243px;
  margin-top: -30px;
  margin-bottom: 16px;
`;

const CardHeaderComponents = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 24px 0px;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: ${(props) => props.top && '24px'};
`;

const Header = ({ data: { authorization_id, details_transaction, event_date, gross_value } }) => {
  const { t } = useTranslation();
  const { country } = getEnv();

  return (
    <>
      <Title>{t('transactions.modalDetail.title')}</Title>
      <Divider />
      <CardHeaderComponents>
        <Row top>
          <TitleAndText title={t('transactions.modalDetail.codeTitle')} text={authorization_id} />
          <TitleAndText
            title={t('transactions.modalDetail.payRef')}
            text={details_transaction?.reference_number || '-'}
            right
          />
        </Row>
        <Row>
          <TitleAndText title={t('transactions.modalDetail.date')} text={formatDate(event_date, 'DD-MM-YYYY | HH:mm', false, 'UTC', country) || '-'} />
          <TitleAndText
            title={t('transactions.modalDetail.totalMount')}
            text={moneyFormat(gross_value, true)}
            right
          />
        </Row>
      </CardHeaderComponents>
      <Divider />
    </>
  );
};

export default Header;
